module.exports = __webpack_public_path__ + "static/gif-uma-vida-financeira-desktop-c1d918699e52a21c1471a5f47c97474a.gif";